module.exports = __webpack_public_path__ + "img/aParty_111523_C.b82d7c08.jpg";